import React from 'react';
import { i18n } from '../../utils';

import info404 from './info-404.png';
import styles from './page-404.scss';

class Page404 extends React.Component {
  public render() {
    return (
      <div className={styles.page}>
        <img src={info404} width="200" height="200" />
        {i18n.t('page.404.title')}
      </div>
    );
  }
}

export default Page404;
